import { Stack } from "@mui/material";
import { convertISODateTimeWithSeconds } from "@entrilia/shared/utilities/dateUtils";
import { type ReportHistoryItem } from "../../../../../../../api/types/svTypes";
import type { PreviewableVersion, ReportConfigurationState } from "../../../store/types/versionHistoryState.types";
import VersionHistoryItem from "./VersionHistoryItem";
import type { VersionId } from "./versionHistory.types";

interface Props {
  versions: ReportHistoryItem[];
  isReportChanged: boolean;
  currentConfiguration: ReportConfigurationState | undefined;
  currentVersionId: VersionId | undefined;
  selectedVersionId: VersionId | undefined;
  previewData: PreviewableVersion | undefined;
  onPreviewVersion: (version: PreviewableVersion) => void;
}

const VersionHistoryList = ({
  versions,
  isReportChanged,
  currentConfiguration,
  currentVersionId,
  selectedVersionId,
  previewData,
  onPreviewVersion,
}: Props) => {
  return (
    <Stack sx={{ gap: 2, p: 2 }}>
      {isReportChanged && currentConfiguration && (
        <Stack key="unsaved-version" sx={{ gap: 1 }}>
          <VersionHistoryItem
            title="Unsaved Version"
            id="unsaved"
            isUnsavedVersion={true}
            versionNumber={0}
            currentVersionId={currentVersionId}
            selectedVersionId={selectedVersionId}
            previewVersionId={previewData?.id}
            onPreview={() =>
              onPreviewVersion({
                id: "unsaved",
                dataSetId: currentConfiguration.dataSetId ?? "",
                configuration: currentConfiguration.currentConfiguration,
                reportType: currentConfiguration.currentReportType,
              } satisfies PreviewableVersion)
            }
          />
        </Stack>
      )}
      {versions.map((version) => (
        <Stack key={version.id} sx={{ gap: 1 }}>
          <VersionHistoryItem
            key={version.id}
            id={version.id}
            title={convertISODateTimeWithSeconds(version.updateAt)}
            versionNumber={version.versionNumber}
            authorName={version.modifiedBy ?? version.createdBy}
            onPreview={() => onPreviewVersion(version)}
            currentVersionId={currentVersionId}
            selectedVersionId={selectedVersionId}
            previewVersionId={previewData?.id}
          />
        </Stack>
      ))}
    </Stack>
  );
};

export default VersionHistoryList;
